<button type="button" class="betslip-mobile-widget" aria-haspopup="dialog"
  [attr.aria-label]="'mobileShortcuts.betSlipSummary' | translate: {
    count: summary().selectionCount, win: (summary().maxWin | number: '1.2-2'),
    stake: (summary().stake | number: '1.2-2'), odds: (summary().totalOdds | number: '1.2-2')
  }" (click)="open.emit()">
  <span class="betslip-mobile-widget__pill" aria-hidden="true">{{ summary().selectionCount }}</span>
  <span class="betslip-mobile-widget__content">
    <span class="betslip-mobile-widget__label">{{ 'mobileShortcuts.betSlip' | translate }}</span>
    <span class="betslip-mobile-widget__details">
      <span>€{{ summary().stake | number: '1.2-2' }} · {{ summary().ticketTypeKey | translate }}</span>
      <span>{{ 'betslip.totalOdds' | translate }} {{ summary().totalOdds | number: '1.2-2' }}</span>
    </span>
  </span>
  <span class="betslip-mobile-widget__payout">
    <span class="betslip-mobile-widget__caption">{{ 'betslip.maxWin' | translate }}</span>
    <span class="betslip-mobile-widget__value" [appPulseOnChange]="maxWinPulseKey()">€{{ summary().maxWin | number: '1.2-2' }}</span>
  </span>
  <span class="material-symbols-outlined betslip-mobile-widget__open" aria-hidden="true">keyboard_arrow_up</span>
</button>
